export const REQUEST_TIMEOUT = 30000;
export const UNAVAILABLE_IMAGE_URL =
  'https://assets.thdstatic.com/images/v1/no-img.svg';
export const MORE_DATES_VALUE = '__more_dates__';
export const PO_JOB_NAME_PLACEHOLDER = 'Add PO/Job Name';
